import * as Types from '../../generated.types'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type UpdateEmployeesMutationVariables = Types.Exact<{
  employeeIds: Array<Types.Scalars['Int']> | Types.Scalars['Int']
  role?: Types.InputMaybe<Types.EmployeeRole>
}>

export type UpdateEmployeesMutation = {
  __typename?: 'Mutation'
  updateEmployees?: { __typename?: 'UpdateEmployeesPayload'; success: boolean } | null
}

export const UpdateEmployeesDocument = `
    mutation UpdateEmployees($employeeIds: [Int!]!, $role: EmployeeRole) {
  updateEmployees(input: {employeeIds: $employeeIds, role: $role}) {
    success
  }
}
    `
export const useUpdateEmployeesMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<UpdateEmployeesMutation, TError, UpdateEmployeesMutationVariables, TContext>
) =>
  useMutation<UpdateEmployeesMutation, TError, UpdateEmployeesMutationVariables, TContext>(
    ['UpdateEmployees'],
    (variables?: UpdateEmployeesMutationVariables) =>
      fetchGql<UpdateEmployeesMutation, UpdateEmployeesMutationVariables>(
        UpdateEmployeesDocument,
        variables
      )(),
    options
  )
